import { Box } from "@chakra-ui/react";
import { CONTENT_WIDTH } from "../../constants/Layout";

/**
 * @typedef {object} Props
 * @property {string | ((params: { defaultMaxWidth: string}) => string)} [maxWidth] css max-width property
 *
 * @param {import("react").PropsWithChildren<Props>} props
 */
export function CenteredContent({ maxWidth = CONTENT_WIDTH, children }) {
  return (
    <Box
      maxW={
        typeof maxWidth === "function"
          ? maxWidth({ defaultMaxWidth: CONTENT_WIDTH })
          : maxWidth
      }
      mx="auto">
      {children}
    </Box>
  );
}
